import AboutPage from '@/components/About/AboutPage';

export default function AboutRoute() {
  return <AboutPage />;
}
